<template>
  <div class="row">
    <div class="col-12">
      <ibox :title="'Przymierzalnia'">
        <!-- <template slot="tools">
                    <router-link to="/porownywarka/dodaj" class="btn btn-primary btn-xs">
                        Dodaj nową bazę
                        <i class="fas fa-plus"></i>
                    </router-link>
                </template> -->
        <template slot="tools">
          <router-link
            :to="`/przymierzalnia/${$route.params.env}/parametry/dodaj`"
            class="btn btn-primary btn-xs"
          >
            Dodaj parametr
            <i class="fas fa-plus"></i>
          </router-link>
        </template>
        <template slot="content" slot-scope="{ setLoading }">
          <data-tables
            ref="parametersTable"
            :url="`vnfr/${$route.params.env}/parameters/list`"
            :columns_list="columns_list"
            @loading="setLoading"
          />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'

export default {
  name: 'ParametersList',
  components: {
    Ibox,
    DataTables
  },
  data() {
    return {
      excel: true,
      columns_list: [
        {
          key: 'id',
          name: this.$t( 'edit' ),
          filter: 'btn',
          btn: a =>
            `<a href="#/przymierzalnia/${this.$route.params.env}/parametry/${a}"><i class="fa fa-edit"></i></a>`
        },
        {
          key: 'type_name',
          name: 'Typ',
          type: 'text',
          sortable: true
        },
        {
          key: 'value',
          name: 'Wartość',
          type: 'text',
          sortable: true
        },
        {
          key: 'visible',
          name: 'Widoczność',
          type: 'text',
          filter: 'boolean',
          sortable: true
        }
      ]
    }
  }
}
</script>
